import React, { Component } from "react";
import { Auth } from "aws-amplify";
import { Helmet } from "react-helmet";
import { AuthContext } from "contexts/auth";
import withAuthentication from "components/withAuthentication/withAuthentication";
import Routes from "Routes";

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isAuthenticating: true,
    };
  }

  async componentDidMount() {
    try {
      const token = await Auth.currentSession();
      let cGroups = token.idToken.payload["cognito:groups"] || [];
      let isAdmin = cGroups.filter((gr) => gr === "admin").length > 0;
      this.context.userIsAdmin(isAdmin);
      this.context.userHasAuthenticated(true);
    } catch (e) {
      if (e !== "No current user") {
        alert(e.message);
      }
    }

    this.setState({ isAuthenticating: false });
  }

  render() {
    if (this.state.isAuthenticating) {
      return null;
    }

    return (
      <React.Fragment>
        <Helmet titleTemplate="Parvo ALERT | %s">
          <meta charSet="utf-8" />
          <meta property="og:site_name" content="Parvo ALERT" />
          <meta property="og:type" content="website" />
        </Helmet>
        <Routes />
      </React.Fragment>
    );
  }
}

App.contextType = AuthContext;
export default withAuthentication(App);
